import { SaveProspectConfigs } from '@/domain/usecases'
import { RemoteSaveProspectConfig } from '@/data/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import env from '@/main/config/env'

export const makeSaveProspectConfigs = (): SaveProspectConfigs => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<string>()

  return new RemoteSaveProspectConfig(url, httpClient)
}
